import { render, staticRenderFns } from "./PosContent.vue?vue&type=template&id=1a6b55f5&scoped=true&"
import script from "./PosContent.vue?vue&type=script&lang=js&"
export * from "./PosContent.vue?vue&type=script&lang=js&"
import style0 from "./PosContent.vue?vue&type=style&index=0&id=1a6b55f5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a6b55f5",
  null
  
)

export default component.exports